import { Component, inject, OnInit } from '@angular/core';
import { ConfigurationsService } from '../../../services/configurations.service';
import { first, map } from 'rxjs';

@Component({
    selector: 'lib-configurations-editor',
    templateUrl: './configurations-editor.component.html',
    styleUrls: ['./configurations-editor.component.css'],
    standalone: false
})
export class ConfigurationsEditorComponent implements OnInit {
  protected configurationsService = inject(ConfigurationsService);
  loading;
  configurations: any[];
  configurationsStrings: string[];

  ngOnInit(): void {
    this.loading = true;
    this.configurationsService
      .getConfigurations(true)
      .pipe(first())
      .subscribe(configurations => {
        this.configurations = configurations;

        this.configurationsStrings = this.configurations.map(d => JSON.stringify(d, undefined, 4));
        this.loading = false;
      });
  }

  save(configuration) {
    this.configurationsService
      .updateConfiguration(configuration)
      .pipe(first())
      .subscribe(_ => alert(`${configuration.id} saved.`));
  }
}
